import React, {useState} from "react";
import {observer} from "mobx-react";
import {IInitBiometricDialogOptions} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/init-biometric.component-props";
import {ModalDialogActionsComponent} from "../../modal-dialog/modal-dialog-actions.component";
import {InitBiometricFooterSectionBox} from "./boxes/init-biometric-footer-section.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {InitBiometricDialogBox} from "./boxes/init-biometric-dialog.box";
import {InitBiometricSectionBox} from "./boxes/init-biometric-info-section.box";
import {HelpOptionBox} from "./boxes/help-option.box";

export const InitBiometricDialogComponent: React.FC<IInitBiometricDialogOptions> = observer((props) => {
    const services = useServices();
    const [isHelpOptionVisible, setHelpOptionVisible] = useState(false);

    
    const _toggleHelpOptionVisible = () => {
        setHelpOptionVisible(!isHelpOptionVisible);
    }

    const _buttonCallBack = async () => {
        try {
            await services.hybrid.getTouchIDFeaturer().getTokenFromSrv();
            services.analytics.sendOrbitUserFlowEvent('Client_TouchID', 'Activation');
        } catch (err) {
            services.logger.error('Failed to init touch ID feature', err);
        }

        props.dialogHandler.close();
    }

    const _getButtonText = (): string => {
        return services.translation.translate('TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON');
    }

    const _renderHelpText = () => {
        if (!isHelpOptionVisible) {
            return null;
        }

        return (
            <InitBiometricFooterSectionBox>
                <ol dangerouslySetInnerHTML={{__html: services.translation.translate("TOUCH_ID_INFO")}}/>
            </InitBiometricFooterSectionBox>
        );
    };






    return (
        <InitBiometricDialogBox>
            <InitBiometricSectionBox>
                <div>
                    {services.translation.translate('TOUCH_ID_CAPTION')}
                </div>
            </InitBiometricSectionBox>
            <ModalDialogActionsComponent primaryAction={{
                onClick: _buttonCallBack,
                text: _getButtonText()
            }} />
            <InitBiometricSectionBox>
                <div>
                    {services.translation.translate('TOUCH_ID_SUB_CAPTION')}
                </div>
            </InitBiometricSectionBox>
            <HelpOptionBox onClick={() => _toggleHelpOptionVisible()}>
                {services.translation.translate("TERMS_AND_CONDITIONS")}
            </HelpOptionBox>
            {_renderHelpText()}
        </InitBiometricDialogBox>
    );

})